const firebaseConfig = {
  apiKey: "AIzaSyCL6ouUOLK1Gd1M1EOaDgyWBcO084QcV7A",
  authDomain: "auth-rider-project.firebaseapp.com",
  projectId: "auth-rider-project",
  storageBucket: "auth-rider-project.appspot.com",
  messagingSenderId: "519702197501",
  appId: "1:519702197501:web:10ddd0c9705b8f1f93fa94",
};
export default firebaseConfig;
